import type { FavoritePageState, FavoritePageStore } from '../domain/types'
import { createStore } from 'zustand'

const INITIAL_STATE: FavoritePageState = {
  results: [],
  loadStatus: 'idle',
  removingProductIds: [],
  allFavouritesRemovalStatus: 'idle',
}

export const favoritePageStore = createFavoritePageStore()

export function createFavoritePageStore(initialState: FavoritePageState = INITIAL_STATE) {
  return createStore<FavoritePageStore>(set => ({
    ...initialState,
    initialize: state => set(() => state),
    setIn: (key, value) => set(state => ({ ...state, [key]: value })),
  }))
}
